import React from 'react';
import clsx from 'clsx';
import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  overline?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: 'left' | 'center';
  actions?: React.ReactNode;
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  overline,
  title,
  description,
  align = 'left',
  actions,
  className,
}) => {
  return (
    <div className={clsx(styles.wrapper, align === 'center' ? styles['align-center'] : styles['align-left'], className)}>
      {overline && <p className={styles.overline}>{overline}</p>}
      <div className={styles.body}>
        <h2 className={styles.title}>{title}</h2>
        {description && <p className={styles.description}>{description}</p>}
      </div>
      {actions && (
        <div
          className={clsx(
            styles.actions,
            align === 'center' ? styles['align-center'] : styles['align-left'],
          )}
        >
          {actions}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
